module.exports = __webpack_public_path__ + "img/玩玩具.40ec3f7f.png";